<template lang="html">

  <article class="oferta row-start aifs">

    <div class="contenedor-textos">

      <h3 class="empresa" v-if="!!data.empresa || !!data.curricular" :style="style.colorMediumBlack">{{data.empresa}}
      <span v-if="data.curricular != null && data.curricular == true && !!!data.paraTitulados"> | PRÁCTICA CURRICULAR</span>
      </h3>

      <h2 class="title-dato">{{data.titulo}}</h2>
      
      <p v-if="data.idperfil==2 && !!!data.paraTitulados && !!data.curricular" >CURRICULAR</p>
      <p v-if="data.idperfil==2 && !!!data.paraTitulados && !data.curricular" >EXTRACURRICULAR</p>
      
      <p class="status" :status="data.estado" v-if="!!data.estado & !!dominios.estadosCandidaturasAlumno">{{dominios.estadosCandidaturasAlumno[data.estado]}}</p>


      <div class="info column-center">
        <p class="-fecha" v-if="!!data.fecha">{{data.fecha}}</p>
        <p class="-lugar" v-if="!!data.provincia">{{data.provincia}}</p>
      </div>

    </div>

    <!-- <candidaturaOptions :url="data.urlAcceso" v-if="data.estado == 16"></candidaturaOptions> -->
    <candidaturaOptions v-if="data.estado == 16 || (data.estado == 1 && !!data.documentacionPendienteFirma && Object.entries(data.documentacionPendienteFirma).length > 0)" 
      :url="data.urlAcceso" :idEstado="data.estado" :type="type" :documentacionPendienteFirma="data.documentacionPendienteFirma"></candidaturaOptions>


    <router-link :to="`${$t(`enlaces.ofertas_${type}`)}/${data.urlAcceso}`" class="enlace-cover" v-if="!iscandidatura"></router-link>

    <router-link v-if="data.paraTitulados == true && (iscandidatura || iscandidatura==null)" :to="`${$t(`enlaces.ofertas_practicas_titulados`)}/${data.urlAcceso}`" class="enlace-cover"></router-link>
    <router-link v-if="data.paraTitulados == false  && (iscandidatura || iscandidatura==null)" :to="`${$t(`enlaces.ofertas_practicas`)}/${data.urlAcceso}`" class="enlace-cover"></router-link>







  </article>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  import VeeValidate from 'vee-validate';

  import candidaturaOptions from '@/components/views/ofertas/candidatura-options';

  export default  {
    name: 'oferta-el',
    props: ['data','type','iscandidatura'],
    data(){
      return{
        clicked : false
      }
    },
    computed : {
      ...mapGetters({
        dominios : 'getDominios',
        style : 'getStyles',
        colors : 'basicColors',
      }),     
    },
    components : {
      'candidaturaOptions' : candidaturaOptions
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';

.oferta{
  width: 100%;
  padding: 20px 0;
  flex-wrap: nowrap;
  -ms-align-items: flex-start;
  align-items: flex-start;
  position: relative;
  flex-wrap: wrap;
  &:first-of-type{
    border-top: none!important;
  }
  *{
    cursor: pointer;
  }
}

.title-dato{
  font-size: 20px;
  margin-bottom: 0;
}

.candidaturas-view .title-dato{
  font-size: 24px;
}

.oferta:last-of-type{
  padding-bottom: 0;
}

.contenedor-textos{
  padding-right: 150px;
  position: relative;
  min-height: 46px;
}

.tips{
  padding-left: 20px;
  background: url("/static/img/icons/tips.svg") left center/14px no-repeat;
}

.tips li{
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 400;
  padding-right: 5px;
  margin-right: 5px;
}

.tips li:last-of-type{
  margin-right: 0;
  padding-right: 0;
  border: none!important;
}

.info{
  width: 150px;
  padding-left: 20px;
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
}

.info p{
  margin-bottom: 5px;
  padding-left: 25px;
  font-weight: 600;
}

.status{
  margin-top: 10px;
  margin-bottom: 0;
}

.contenedor-input{
  margin-bottom: 0;
}


@media screen and (max-width: 550px){

  .oferta{
    padding: 15px 0;
  }
  
  .contenedor-textos{
    padding-right: 0;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;
    justify-content: flex-start;
    -ms-align-items: flex-start;
    align-items: flex-start;
  }

  .info{
    position: relative;
    width: 100%;
    padding-left: 0;
    margin-top: 10px;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    -o-flex-direction: row;
    flex-direction: row;
    justify-content: flex-start;
    -webkit-justify-content: flex-start;
  }

  .info p{
    width: auto;
    margin-right: 15px;
    padding-left: 20px;
  }


  
  .status{
    -webkit-order: 2;
    -moz-order: 2;
    -ms-order: 2;
    -o-order: 2;
    order: 2;
    margin-left: 0;
    margin-top: 5px;
  }

  .title-dato{
    font-size: 18px;
  }

}



</style>



// WEBPACK FOOTER //
// src/components/views/home/oferta-el.vue